import router from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ITEM_ACTIVE_STATUS } from '@/utils/constants';
import LoadingScreen from 'src/containers/Cart/Components/LoadingScreen';

export const CategoryProductCount = ({ classes = '', ...props }) => {
  const [count, setCount] = useState(0);

  const {
    catalogData: { categories, catalog_items, productTags },
    showOutOfStockItem,
  } = useSelector((state) => ({
    catalogData: state.catalogReducer,
    showOutOfStockItem: !state.storeReducer.store?.services?.hide_out_of_stock,
  }));

  useEffect(() => {
    if ([...productTags, ...categories].length) {
      const catId = props?.config?.category_id || router?.query?.cid;
      if (catId) {
        const specificCatalogItem = catalog_items[catId];
        setCount(
          specificCatalogItem?.filter?.(
            (item) =>
              item.is_active === ITEM_ACTIVE_STATUS.ACTIVE &&
              (showOutOfStockItem || !!item?.available)
          )?.length
        );
      }
    }
  }, [categories, productTags, catalog_items]);

  return (
    <>
      {count > 0 ? (
        <div className={`fade-in-label ttc product-count tw-h-[24px] ${classes || ''}`}>
          {count} Product{count === 1 ? '' : 's'}
        </div>
      ) : (
        <div className={`tw-h-[24px] tw-w-[127px] ${classes || ''}`}>
          <LoadingScreen
            rowNums={1}
            rowContainerStyles={{ paddingTop: 0, paddingBottom: 0 }}
          />
        </div>
      )}
    </>
  );
};
